import AsyncCallHandler from '../common/AsyncCallHandler'
import NEXUS_CONST from '../common/constants'
import * as utils from '../common/utils'
export const postUserLog = data => AsyncCallHandler(NEXUS_CONST.UPDATE_USER_LOG, NEXUS_CONST.POST, utils.getMetricData(data))
export const exportData = (url, name, inputData ) => {
    AsyncCallHandler(url, NEXUS_CONST.POST, inputData, NEXUS_CONST.BLOB).then(
      (res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", name + ".xlsx");
        document.body.appendChild(link);
        link.click();
      }
    );
  };